import { SET_LANG_UNIVERSAL } from './constants';

const actions = {
    set: (payload) => ({
        type: SET_LANG_UNIVERSAL,
        payload,
    }),
};
export default actions;
